<div class="ui segment box-shadow-new" (click)="itemClick.emit(item)">
  <div class="main-content-wrapper">
    <div class="preview-wrapper">
      <img [src]="item?.previewUrl" />
    </div>
    <div class="text-wrapper">
      <div class="template-name">{{ item?.name }}</div>
      <div class="sanity-product-title">{{ item?.sanityProductTitle }}</div>
      <div *ngIf="item?.filters?.length" class="sanity-product-options">
        <ng-container *ngFor="let filter of item.filters">
          <ng-container [ngSwitch]="filter?.key">
            <gd-product-templates-list-item-filter [filter]="filter"></gd-product-templates-list-item-filter>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>
  <div class="bottom-text-wrapper">
    <div class="created-at">{{ 'txt_created_at' | translate }} {{ item?.createdAt | formattedDateUtc }}</div>
  </div>
  <div *ngIf="showActionButtons" class="primary-action-buttons">
    <button
      *ngIf="showPlaceOrderButton"
      class="ui primary fluid button"
      (click)="onPlaceOrderButtonClick()"
      data-lokalise
      data-key="txt_product_templates_place_order_button"
    ></button>
    <button
      class="ui primary fluid button"
      (click)="onAddToStoreButtonClick()"
      data-lokalise
      data-key="txt_add_to_store"
    ></button>
  </div>
  <div *ngIf="showEditButton" class="dropdown-menu-wrapper">
    <gd-dropdown-menu class="templates-list-item-dropdown-menu" [positionLeft]="true" [showDefaultButtonBorder]="true">
      <div class="item" (click)="onEditButtonClick()">
        <i class="pencil icon"></i>
        {{ 'txt_edit' | translate }}
      </div>
      <div class="item" (click)="onRenameButtonClick()">
        <i class="edit icon"></i>
        {{ 'txt_rename' | translate }}
      </div>
      <div class="item" (click)="onDuplicateButtonClick()">
        <i class="copy outline icon"></i>
        {{ 'txt_duplicate' | translate }}
      </div>
      <div class="item" [ngxClipboard] [cbContent]="item.id" (cbOnSuccess)="copyTemplateId()">
        <i class="copy outline icon"></i>
        {{ 'txt_copy_template_id' | translate }}
      </div>
      <div class="item item-action-delete" (click)="onDeleteButtonClick()">
        <i class="trash icon"></i>
        {{ 'txt_delete' | translate }}
      </div>
    </gd-dropdown-menu>
  </div>
</div>
